export const validateContactForm = (formData: { name: string; email: string; subject: string; message: string }) => {
  const errors: {
    name?: string;
    email?: string;
    subject?: string;
    message?: string;
    status?: string;
  } = {};

  // ── Name ─────────────────────────────
  if (!formData.name.trim()) {
    errors.name = "Name is required";
  } else if (formData.name.trim().length < 2) {
    errors.name = "Name must be at least 2 characters";
  }

  // ── Email ─────────────────────────────
  if (!formData.email.trim()) {
    errors.email = "Email is required";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    errors.email = "Invalid email format";
  }

  // ── Subject ───────────────────────────
  if (!formData.subject.trim()) {
    errors.subject = "Subject is required";
  }

  // ── Message ───────────────────────────
  if (!formData.message.trim()) {
    errors.message = "Message is required";
  } else if (formData.message.trim().length < 10) {
    errors.message = "Message must be at least 10 characters";
  }

  return errors;
};
